bindTargetNavigation = require('../../deal/responsive/frontend/bind_target_navigation')

Getaways = window.Getaways ?= {}
Getaways.TripAdvisor ?= {}
Getaways.TripAdvisor.Templates ?= {}

Getaways.TripAdvisor.Templates.getaways_trip_advisor_review = require '../trip_advisor_review.html.mustache'
Getaways.TripAdvisor.Templates.getaways_touch_trip_advisor_review = require '../responsive/trip_advisor_review.html.mustache'

# Duration of scroll down animation from the deal title to the TA reviews in desktop (miliseconds)
SCROLL_ANIMATION_DURATION = 1000

# Averaged body length (used to include read more trigger)
BODY_DISPLAY_LIMIT_DESKTOP = 290

# Averaged body length (used to include the expanded class)
BODY_DISPLAY_LIMIT_TOUCH = 150

# Sticky Header Height (used to add an offset on DealV2)
STICKY_HEADER_HEIGHT = 65

Getaways.TripAdvisor.init = (options, done) ->
  $target = null
  reviewsLoaded = false
  template = null
  url = options.tripAdvisor?.reviewsUrl

  { January, February, March, April, May, June, July, August, September, October, November, December } =
  I18n.t( 'js.modules.getaways.booking_calendar.touch.month_names' )
  toMonthName = [January, February, March, April, May, June, July, August, September, October, November, December]

  loadTripAdvisorReviewDetails = (promise) ->

    if !options.tripAdvisor?.shouldShowTripAdvisorReviewsDetails
      $target.html('')
      return

    $.getJSON(url)
    .success( (data) ->

      unless data?.reviews?.length
        message = I18n.translate('js.modules.getaways.trip_advisor.no_reviews_for_lang')
        content = "<p class='error-text'>#{message}</p>"
        $target.html(content)
        return

      formattedReviews = formatReviews(data.reviews)

      hash =
        translate: -> (key) -> I18n.t key
        tripAdvisor:
          reviews: formattedReviews

      renderedTemplate = template.render(hash)

      $target.html(renderedTemplate)

      bindTAExpandClicks()

      reviewsLoaded = true
    )
    .fail( (jqxhr, textStatus, error ) ->
      message = I18n.translate('js.modules.getaways.trip_advisor.error_text')
      content = "<p class='error-text'>#{message}</p>"
      $target.html(content)
    ).always( -> promise?.resolve())

  showTripAdvisorDrawer = (duration = 400) ->
    $tripAdvisorDrawer = $(".toggle-drawer.trip-advisor-block")
    $drawerContent = $tripAdvisorDrawer?.find('.toggle-content')
    $drawerContent?.slideDown
      duration: duration
      complete: ->
        $tripAdvisorDrawer.addClass("open")

  animateScrollToTarget = (target, duration, offset) ->
    $scrollPane = $('body,html')
    stickyOffset = if (options?.stickyHeader) then STICKY_HEADER_HEIGHT else 0

    $scrollPane.animate({
      scrollTop: target.offset().top - stickyOffset - offset
    }, duration)

    return

  # Module Level Events
  initTripAdvisorTouch = ->
    $('#trip-advisor-header')?.on 'click', ->
      loadTripAdvisorReviewDetails(options.dealUUID) if !reviewsLoaded

    $tripAdvisorReviewBlock = $(".toggle-drawer.trip-advisor-block")
    $tripAdvisorHighlight = $('a.trip-advisor-rating')

    bindTargetNavigation $tripAdvisorHighlight, (promise) ->
      loadTripAdvisorReviewDetails(promise) if !reviewsLoaded
      showTripAdvisorDrawer(0)

  initTADesktopHeaderLink = ->
    $headerLinkContainer = $('#trip-advisor-summary')
    $reviewsContainer = $('#trip-advisor-reviews')

    $headerLinkContainer?.on 'click', ->
      offset = 0
      animateScrollToTarget($reviewsContainer, SCROLL_ANIMATION_DURATION, offset)

    return

  # Review Level Events
  bindTAExpandClicks = ->
    $items = $('.ta-review')

    $items?.each( ->
      $thisElement = $(this)

      if options.touch
        bindTATouchExpand($thisElement)
      else
        bindTAShowLink($thisElement)
    )

  bindTAShowLink = ($element) ->
    $showMoreLink = $element.find('.ta-show-more')
    $description = $element.find('.ta-review-description')
    $textContainer = $element.find('.ta-review-text')

    $showMoreLink.one('click', ->
      fullText = $textContainer?.data('text')
      $description?.toggleClass('expanded')
      $textContainer.html(fullText)
    )
    return

  bindTATouchExpand = ($element) ->
    if !$element.hasClass('expanded')
      $element.on('click', ->
        $element.toggleClass('expanded')
      )


  # formatting helpers
  formatReviews = (reviews) ->
    for review, i in reviews
      formatForDisplay(review, i)

  formatForDisplay = (review, reviewIndex) ->

    handleLongReviewText(review, reviewIndex)

    review.ratingSpriteNumber = calculateRatingSpriteNumber(review)
    review.prettyPublishedDate = prettifyReviewDate(review)
    review.index = reviewIndex

    review

  dateStringToDate = (dateString) ->
    errMsg = 'Date string YYYY-MM-DD is required'
    if typeof(dateString) != 'string'
      throw TypeError errMsg
    dateParts = dateString.split('-')
    if dateParts.length != 3
      throw TypeError errMsg
    new Date(+dateParts[0], (+dateParts[1]) - 1, +dateParts[2])


  prettifyDate = (dateString) ->
    if isNaN(Date.parse(dateString))
      return null

    date = dateStringToDate(dateString)
    I18n.t('js.modules.getaways.trip_advisor.review_date_format', {
      month_name: toMonthName[date.getMonth()],
      day: date.getDate(),
      year: date.getFullYear()
    })

  prettifyReviewDate = (review) ->
    prettyPublishedDate = prettifyDate(review.publishedDate)

  calculateRatingSpriteNumber = (review) ->
    ratingSpriteNumber = parseFloat(review.rating) * 2

  handleLongReviewText = (review, reviewIndex) ->

    if options.touch
      bodyDisplayLimit = BODY_DISPLAY_LIMIT_TOUCH
    else
      bodyDisplayLimit = BODY_DISPLAY_LIMIT_DESKTOP

    review.showReadMore = isShowMoreNeeded(review, bodyDisplayLimit)

    if review.showReadMore and !options.touch
      review.truncatedBody = truncateReviewText(review, bodyDisplayLimit)

  isShowMoreNeeded = (review, readMoreLimit) ->
    showReadMore = false

    if review.body?.length > readMoreLimit
      showReadMore = true

    showReadMore

  truncateReviewText = (review, readMoreLimit) ->
    truncatedBody = review.body.slice(0, readMoreLimit)
    truncatedBody += '...'

    truncatedBody

  $target = $('#trip-advisor-body')
  unless $target?
    done()
    return ''

  if options.touch
    template = Getaways.TripAdvisor.Templates.getaways_touch_trip_advisor_review
    if options.tripAdvisor?.hasTAReviews
      initTripAdvisorTouch()
  else
    template = Getaways.TripAdvisor.Templates.getaways_trip_advisor_review
    if options.tripAdvisor?.hasTAReviews
      initTADesktopHeaderLink()
      loadTripAdvisorReviewDetails()

  done()

module.exports = Getaways.TripAdvisor
